import { ProductLaneModel } from '../../components/AutoGenerate/types/ProductLaneModel'
import { ProductTile } from '../../components/AutoGenerate/types/ProductTile'
import { BFFPageData } from '../../services/serviceClients/BffClient'
import { ReviewsResponse } from '../../types/Contentful/ContentfulTypes'
import { ProductLaneType, CategoryPageSection } from '../../types/TemplateConfiguration'
import { LaneTileBuilder } from './LaneTileBuilder'

/**
 * Builds complete ProductLaneModel from ProductLaneType section
 */
export class LaneModelBuilder {
  /**
   * Builds lane model with all required fields and tiles
   */
  static build(
    section: ProductLaneType,
    sectionNumber: number,
    nextSection: CategoryPageSection | undefined,
    reviewsData: ReviewsResponse | undefined,
    enableCampaignCallouts: boolean | undefined,
    pageDataFromBFF: BFFPageData
  ): ProductLaneModel | undefined {
    if (!section.items?.length) {
      return undefined
    }

    const builder = new LaneTileBuilder(pageDataFromBFF, reviewsData)
    const tiles: ProductTile[] = []

    for (const item of section.items) {
      const tile = builder.buildTile(item, enableCampaignCallouts)
      if (tile) tiles.push(tile)
    }

    return {
      ...(section.title?.value && { title: section.title.value }),
      sectionNumber,
      type: section.type,
      ...(section.sectionId && { sectionId: section.sectionId }),
      ...(nextSection?.nextSectionId && { nextSectionId: nextSection.nextSectionId }),
      ...(nextSection?.nextSectionTitle && { nextSectionTitle: nextSection.nextSectionTitle }),
      ...(section.subtitle?.value && { subtitle: section.subtitle.value }),
      ...(section.hideProductDescription && {
        hideProductDescription: section.hideProductDescription
      }),
      ...(section.enableSeeAllCTA && { enableSeeAllCTA: section.enableSeeAllCTA }),
      ...(section.seeAllCta && { seeAllCta: section.seeAllCta }),
      tiles,
      isAutomatedLane: false,
      automationEnabled: section.automationEnabled ?? false
    }
  }
}
